import React, { useContext, useState, useEffect } from 'react';
import './App.css';
import ClubRegistrationLandingPage from './pages/ClubRegistrationLandingPage/ClubRegistrationLandingPage';
import PingNationClubRegistrationTile from './components/PingNationClubRegistrationTile/PingNationClubRegistrationTile';
import SlideOutModal from './components/ClubRegistrationSlideOutModal/ClubRegistrationSlideOutModal';
import { ClubsProvider } from './context/clubsContext';
import { NotificationProvider } from './context/notificationContext';
import { LocalizationContext } from './context/localizationContext';

function App(props) {
  const { organization } = props;
  const [isTileView, setTileView] = useState(true);
  const localization = useContext(LocalizationContext);
  const { localizationDispatch } = localization;

  const toggleModal = () => {
    setTileView(!isTileView);
  };

  const getClubCount = (clubList) => {
    let clubCount = 0;
    clubList?.forEach((club) => {
      if (club?.clubs) {
        clubCount += club.clubs.length;
      } else {
        clubCount += 1;
      }
    });

    return clubCount;
  };

  useEffect(() => {
    localStorage.setItem('Organization', organization);
    if (organization !== 'US') {
      localizationDispatch({
        type: 'SET_LOCALIZATION',
        localization: organization,
      });
    }
  }, []);

  return (
    <div className="App">
      <ClubsProvider>
        <NotificationProvider>
          <PingNationClubRegistrationTile
            isTileView={isTileView}
            toggleModal={toggleModal}
            getClubCount={getClubCount}
          />
          <SlideOutModal isOpen={!isTileView} toggleModal={toggleModal}>
            <ClubRegistrationLandingPage
              toggleModal={toggleModal}
              getClubCount={getClubCount}
            />
          </SlideOutModal>
        </NotificationProvider>
      </ClubsProvider>
    </div>
  );
}

export default App;
